module.exports = __webpack_public_path__ + "static/media/03_Design.1597e738.png";